import { WORKSPACE_AGENT_PANEL_WIDTH_CSS_VARIABLE } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';

export const getWorkspaceAgentPanelWidthCSSValue = (): string => `var(${WORKSPACE_AGENT_PANEL_WIDTH_CSS_VARIABLE})`;
